interface monthsTranslateTypes {
  [key: string]: string
}

const timeFormatter = (time: string) => {
  const timeOffset = new Date().getTimezoneOffset() / 60;
  const localTimeString =
      new Date(time).toUTCString()//+ ` GMT${timeOffset}`;  

  //TODO Разобраться с выводом даты на MacOS
  /*const userAgent = window.navigator.userAgent.toLowerCase()
  const safari = /safari/.test( userAgent );
  const ios = /iphone|ipod|ipad/.test( userAgent );
  if (safari || ios) {
    // Wed, 26 May 2021 07:15:01 GMT GMT-3
    const localTimeStringSplitSpace = localTimeString.split(' ')
    const day = localTimeStringSplitSpace[1]
    let month = localTimeStringSplitSpace[2]
    let hours = +localTimeStringSplitSpace[4].split(":")[0]
    const minutes = localTimeStringSplitSpace[4].split(':')[1]
    const monthsTranslate: monthsTranslateTypes = {
      "Jan": 'Января',
      "Feb": 'Февраля',
      "Mar": 'Марта',
      "Apr": 'Апреля',
      "May": 'Мая',
      "Jun": 'Июня',
      "Jul": 'Июля',
      "Aug": 'Августа',
      "Sep": 'Сентября',
      "Oct": 'Октября',
      "Nov": 'Ноября',
      "Dec": 'Декабря',
    }
    hours+= Math.abs(timeOffset) * 2
    Object.keys(monthsTranslate).forEach((monthEl: string) => {
      if (monthEl === month) month = monthsTranslate[monthEl]
    })

    return `${day} ${month}, ${hours}:${minutes}`
  }*/

  const formatter = new Intl.DateTimeFormat("ru", {
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
  return formatter.format(new Date(time));
};

export default timeFormatter;
